import React from "react";
import "../assests/CSS/Thiyapediacomp1.css";

const Thiyapediacomp1 = () => {
  return (
    <div className="th-container">
      <div className="th-content">
        <h2 className="th-heading">
          Find the country you’re looking for <br />
          on  <span className="th-brand">THHIYAPEDIA</span>
        </h2>

        <div className="th-search-box">
          <input
            type="text"
            placeholder="Service, Industry or region"
            className="th-input"
          />
          <input
            type="text"
            placeholder="Country/ Region"
            className="th-input"
          />
          <button className="th-btn">Search</button>
        </div>
      </div>
    </div>
  );
};

export default Thiyapediacomp1;
